import { useEffect } from 'react';
import { FULLSCREEN_FILE_VIEWER_MAX_ZOOM, FULLSCREEN_FILE_VIEWER_MIN_ZOOM, } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/FullScreenFilesViewer/constants';
export var useFileViewerKeyboardListener = function (currentScale, increaseScale, decreaseScale, rotateRight, rotateLeft) {
    var handleKeyDown = function (event) {
        switch (event.key) {
            case '+': {
                return currentScale < FULLSCREEN_FILE_VIEWER_MAX_ZOOM ? increaseScale() : null;
            }
            case '-': {
                return currentScale > FULLSCREEN_FILE_VIEWER_MIN_ZOOM ? decreaseScale() : null;
            }
            case 'r': {
                return rotateRight();
            }
            case 'l': {
                return rotateLeft();
            }
        }
    };
    useEffect(function () {
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    });
};
